import React, { PureComponent } from "react";
import ExpandedOfferBlock from "./ExpandedOfferBlock";
import CompareModalScreen from "./CompareModalScreen";
import {
  initApplicationResponseSelector,
  userInfoSelector,
  availableApplicationsCoveringCartSelector,
  applicationsNotCoveringCartSelector,
  trendingsVisitID,
  subscribingDataSelector,
  discountDataSelector,
  cartAmountSelector,
} from '../selectors';
import {editCart, providerFailed, selectOffer, nextStep, getRecommendationsForItem} from '../actions';
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { BlueBtn } from "components/Controls";
import { AnalyticAPI } from "api/analytic";
import ModalSortBtns from "components/Controls/ModalSortBtns";
import CheckIconGreen from "assets/img/check-icon-green.png";
import { closeModal } from "../../MultistepModal/actions";

import "./styles.scss";
import { OFFER_ORDER } from "./constants";
// import { UOWN_FIRST_OFFER_ORDER } from "./constants";
import { CustomTooltip } from "../../../components/DataDisplay";
import CartInfo from "components/DataDisplay/CartInfo";
import CartApprovalScreen from "./CartApprovalScreen";
import { getOfferPromo } from "./helpers";
import {logEvent} from '../../EmbeddableWidget/actions';

class Step3 extends PureComponent {
  state = {
    compareOffers: [],
    compareModal: false,
    orderedOffers: [],
    offersWithOptions: [],
    isCompareMode: false,
    maxApproval: 0,
  };

  constructor(props) {
    super(props);
    this.state.orderedOffers = this.props.availableApplications;
    this.state.isCartApprovalFlow =
      this.props.availableApplications.length === 0 &&
      this.props.notAvailableApplications.length > 0;
  }

  componentDidMount() {
    const {
      availableApplications,
      notAvailableApplications,
      token,
      visitID,
      logEvent,
      cartAmountSelector
    } = this.props;

    AnalyticAPI.send_analytic_event(token, "approvals", visitID);

    if (
      availableApplications.length === 0 &&
      notAvailableApplications.length > 0
    ) {
      const maxApproval = this.maxApprovalAmount();
      this.setState({ maxApproval });
    }

    const onlySnap = availableApplications.every(
      o => o.specific_provider_name === 'snap'
    );

    const sortedOffers = availableApplications
      .map(offer => {
        const cartTotal = parseFloat(cartAmountSelector) - parseFloat(offer.full_taxes || 0);
        const promo = getOfferPromo(offer, cartTotal, { onlySnap });

        return {
          ...offer,
          cart_total: cartTotal,
          promo,
        };
      })
      .sort((a, b) => {
        // const promoDiff = (b.promo ?? 0) - (a.promo ?? 0);
        // if (promoDiff !== 0) return promoDiff;

        const indexA = OFFER_ORDER.indexOf(a.specific_provider_name);
        const indexB = OFFER_ORDER.indexOf(b.specific_provider_name);

        return indexA - indexB;
      });

    this.setState({ orderedOffers: sortedOffers });

    if (availableApplications.length === 0 && notAvailableApplications.length === 0) {
      // No offers available at all - redirect to nobody approved
      this.props.nextStep({ step: 'nobodyApprovedStep' });
    } else if (availableApplications.length === 0 && notAvailableApplications.length > 0) {
      logEvent({name: 'approved partial value'})
    } else if (availableApplications.length > 0) {
      logEvent({name: 'approved full cart'})
    }
  }
  maxApprovalAmount = () => {
    const { notAvailableApplications } = this.props;
    return Math.max(...notAvailableApplications.map((o) => o.approved_amount));
  };

  callbackOrdersOffersData = (offers) => {
    this.setState({ orderedOffers: [...offers] });
  };

  callbackCompareToggle = () => {
    this.setState({ isCompareMode: !this.state.isCompareMode });
  };

  addToCompare = (offers) => {
    this.setState({ compareOffers: [...offers] });
  };

  renderCompareBtn = () => {
    const { isCompareMode, compareOffers } = this.state;

    if (isCompareMode && compareOffers.length > 1) {
      return (
        <div className="compare-total">
          <BlueBtn onClick={() => this.toggleCompareModal()}>
            COMPARE SELECTED PLANS ({compareOffers.length})
          </BlueBtn>
        </div>
      );
    }
  };

  toggleCompareModal = () => {
    this.setState({ compareModal: !this.state.compareModal });
  };

  selectOffer = (providerName) => {
    const { compareOffers } = this.state;
    const offer = compareOffers.find(
      (elem) => elem.specificProviderName == providerName
    );
    if (!offer) {
      return;
    }
    this.props.selectOffer({ selectedOffer: offer.dataForApprouve });
  };

  addOffersForSort = (offer) => {
    this.setState(({ offersWithOptions }) => {
      const newSortedOffers = offersWithOptions.filter(
        (elem) => elem.specific_provider_name !== offer.specific_provider_name
      );
      return { offersWithOptions: [...newSortedOffers, offer] };
    });
  };

  render() {
    const {
      initAppResponse,
      availableApplications,
      notAvailableApplications,
      items,
      discount,
      editCart,
      logEvent,
      cartAmountSelector,
    } = this.props;

    const {
      isCompareMode,
      compareOffers,
      compareModal,
      orderedOffers,
      offersWithOptions,
    } = this.state;

    const isFlexshopperOnly =
      orderedOffers.length === 1 &&
      orderedOffers[0].provider === "flexshopper" &&
      orderedOffers[0].authentication_is_required;

    let cartApprovalMode = null;
    if (this.state.isCartApprovalFlow) {
      cartApprovalMode = availableApplications.length > 0 ? "under" : "over";
    }

    if (cartApprovalMode) {
      return (
        <CartApprovalScreen
          mode={cartApprovalMode}
          availableApplications={availableApplications}
          notAvailableApplications={notAvailableApplications}
          items={items}
          cartAmount={cartAmountSelector}
          editCart={editCart}
          selectOffer={this.props.selectOffer}
          getRecommendationsForItem={this.props.getRecommendationsForItem}
          logEvent={logEvent}
        />
      );
    }

    return (
      <div>
        <div className="header-text-block step3-header-block">
          <div className="header-text-block__icon">
            <img src={CheckIconGreen} />
          </div>
          <div className="congrats-text">
            Congrats, You’re Prequalified!
            <CustomTooltip
              text={
                "A prequalification is not a guarantee of final approval. Final approval amount may vary. In some instances, depending on the information in the application, applicants may be approved for an amount greater than prequalification amount."
              }
            />
          </div>
        </div>
        <div className="header-text-block pb">
          <div className="info-text">
            Please review and select a payment plan option below to complete
            your order.
          </div>
        </div>

        <div className="step3 paypair-step-content">
          <CompareModalScreen
            closeModal={this.toggleCompareModal}
            isOpen={compareModal}
            offers={compareOffers}
            selectOffer={this.selectOffer}
          />
          {isFlexshopperOnly && (
            <div>
              <h2 className="subtitle font-center">
                We've found your Flexshopper account!
              </h2>
              <h2 className="title2 font-center "></h2>
            </div>
          )}

          {orderedOffers.length > 1 && (
            <ModalSortBtns
              callbackOrderedOffers={this.callbackOrdersOffersData}
              callbackCompareToggle={this.callbackCompareToggle}
              offers={orderedOffers}
              offersWithOptions={offersWithOptions}
              isCompareMode={isCompareMode}
              logEvent={logEvent}
            />
          )}

          <div className="line"></div>

          <div className="step3__content flex flex--column">
            {orderedOffers.map((offer, index) => {
              return (
                <ExpandedOfferBlock
                  offer={offer}
                  key={offer.specific_provider_name}
                  isCompareMode={isCompareMode}
                  addToCompare={this.addToCompare}
                  compareOffers={compareOffers}
                  addOffersForSort={this.addOffersForSort}
                />
              );
            })}
            {this.renderCompareBtn()}
            {notAvailableApplications.length > 0 && (
              <div>
                <p className="section_title">
                  The plans below are approvals but do not cover your cart
                  total.
                </p>
                <div className="section_header_message">
                  In order to complete your purchase with these plans, please
                  edit your cart so your total is equal to or less than the
                  approval amount.
                </div>
                <div className="gray-section">
                  <div className="not_enought_amount-block">
                    {notAvailableApplications.map((offer, index) => {
                      return (
                        <ExpandedOfferBlock
                          key={`${index}-${offer.provider}`}
                          offer={offer}
                          available={false}
                          addToCompare={this.addToCompare}
                          compareOffers={compareOffers}
                          addOffersForSort={this.addOffersForSort}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  initAppResponse: initApplicationResponseSelector(),
  availableApplications: availableApplicationsCoveringCartSelector(),
  notAvailableApplications: applicationsNotCoveringCartSelector(),
  userInfo: userInfoSelector(),
  token: tokenSelector(),
  visitID: trendingsVisitID(),
  items: subscribingDataSelector(),
  discount: discountDataSelector(),
  cartAmountSelector: cartAmountSelector(),
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
    closeModal: () => dispatch(closeModal()),
    editCart: (values) => dispatch(editCart(values)),
    logEvent: (value) => dispatch(logEvent(value)),
    nextStep: (payload) => dispatch(nextStep(payload)),
    getRecommendationsForItem: (payload) =>
      dispatch(getRecommendationsForItem(payload)),
  };
};

Step3 = connect(mapStateToProps, mapDispatchToProps)(Step3);

export default Step3;
